import { formatMultipleSortingForEndpoint } from '@app/components/data-table/lib/parsers';
import Page from '@app/components/layout/page/page';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import { useGetSoldPackagingList } from '@shared/api/hooks/sold-goods/packaging';
import { SoldGoodsPackagingListParams } from '@shared/api/types';
import { parseAsString, useQueryState } from 'nuqs';
import SoldPackagingTable from '../components/sold-packaging-table';
import { packagingFilters } from '../filters';

export default function SoldPackagingListPage() {
  const [search] = useQueryState('packagingName', parseAsString);
  const { page, perPage, sort, ...filterStates } = useDataTableQueryState({
    filters: Object.values(packagingFilters).map(({ column }) => column),
  });

  const params: SoldGoodsPackagingListParams = {
    page,
    page_size: perPage,
    search: search || undefined,
    sort: formatMultipleSortingForEndpoint(sort! || []),
  };
  // Build the API params from the table filters
  Object.values(packagingFilters).forEach(({ apiKey, column }) => {
    params[apiKey] = filterStates[column];
  });

  const { data, status, isLoading, isFetchedAfterMount, isPreviousData } =
    useGetSoldPackagingList(params);

  return (
    <Page name="Packaging" page="subpage">
      <SoldPackagingTable
        data={data}
        status={status}
        pageSize={perPage}
        isLoading={(!isFetchedAfterMount && isPreviousData) || isLoading}
        isPreviousData={isPreviousData}
      />
    </Page>
  );
}
